// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import components
import './item';

// Import style for web component
import styles from './web-component-style.scss?inline';

/**
 * Web component representing a group of addons
 *
 * @augments LitElement
 */
@customElement( 'uap-page-addons-group-placeholder' ) // eslint-disable-line require-jsdoc
export class AutomatorPageAddonsGroupPlaceholder extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	/**
	 * Renders the component
	 *
	 * @return {TemplateResult|undefined} The template
	 */
	render() {
		return html`
			<div class="grid">
				<uap-page-addons-group-placeholder-item></uap-page-addons-group-placeholder-item>
				<uap-page-addons-group-placeholder-item></uap-page-addons-group-placeholder-item>
			</div>
		`;
	}
}